<template>
    <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            multi-sort
            no-data-text="Es liegen noch keine Daten vor."
            no-results-text="Es wurden keine Ergebnisse gefunden."
            loading-text="Lädt..."
            :footer-props="{
                            itemsPerPageText: 'Einträge pro Seite',
                            itemsPerPageOptions: [25,50,100, -1],
                            itemsPerPageAllText: 'Alle'
                        }"

    >

    </v-data-table>
</template>

<script>
    export default {
        props: ['headers', 'search', 'items'],
    }
</script>

<style scoped>

</style>